<template>
  <div>
    <OQInput
      :label="label"
      :hint="hint"
      :placeholder="placeholder"
      :value="value"
      :error="invalid_email ? 'Ошибка ввода' : undefined"
      type="email"
      @input="doChangeEmail"
    />
  </div>
</template>

<script>
import OQInput from "@/components/UI/OQInput.vue";

export default {
  name: "OQEmailInput",
  components: { OQInput },
  props: ["label", "hint", "title", "placeholder", "value"],
  data() {
    return { invalid_email: false };
  },
  methods: {
    doChangeEmail(v) {
      this.invalid_email = v && !this.validateEmail(v);
      this.$emit("input", v);
      this.$emit("hasError", this.invalid_email);
    },
    validateEmail(email) {
      return !!String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
  },
};
</script>

<style scoped></style>
